import React from 'react';
import TabTicketByParams from '../Tabs/TabTicketByParams';
import styled from 'styled-components';
import TicketFilterV2 from './Filter';

const OpenTickets = () => {
  return (
    <Container>
      <TicketFilterV2 />
      <div className="tickets">
        <TabTicketByParams v2 tableKey={'OPEN_TICKET'} />
      </div>
    </Container>
  );
};

export default OpenTickets;

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .tickets {
    flex: 1;
    position: relative;
  }
`;